import type { UIComponent } from "@gik/core/types/UI";
import bemBlock from "@gik/core/utils/bemBlock";
import { BackgroundImage } from "@gik/ui-legacy/BackgroundImage";
import { HTMLParser } from "@gik/ui-legacy/HTMLParser";
import { KeepProportions } from "@gik/ui-legacy/KeepProportions";
import { CircleBone, ParagraphBone } from "@gik/ui-legacy/SkeletonLoader";
import type React from "react";

export type RecipientTileProps = {
	title?: string;
	imageUrl?: string;
	variant?: string;
} & UIComponent;

export default function RecipientTile({
	className,
	title,
	variant,
	imageUrl,
}: RecipientTileProps): React.ReactElement {
	const bem = bemBlock("recipient-tile");

	if (!imageUrl) return <RecipientTileSkeleton />;

	return (
		<div className={bem(null, [{ [variant]: variant }], className)}>
			<KeepProportions proportion={1}>
				<BackgroundImage
					src={imageUrl}
					className={bem("box")}
				></BackgroundImage>
			</KeepProportions>

			<span className={bem("title")}>
				<HTMLParser rawHtml={title} />
			</span>
		</div>
	);
}

export const RecipientTileSkeleton = (): React.ReactElement => {
	const bem = bemBlock(`recipient-tile-skeleton`);
	return (
		<div className={`${bem()}`}>
			<KeepProportions proportion={1}>
				<div className={bem("image-wrapper")}>
					<CircleBone className={bem("image")} />
				</div>
			</KeepProportions>
			<main>
				<ParagraphBone words={2} className={bem("category")} />
			</main>
		</div>
	);
};
